module.exports = __webpack_public_path__ + "static/bookmarkfilter-7c69d3caea0659e0b9b038c54ce36362.png";